module.exports = __webpack_public_path__ + "static/media/Mehmet Sakin_DT.5e740916.jpg";